import styled from 'styled-components'
import { themeGet } from 'styled-system'
import elemBannerBackground from './assets/elemBannerBackground.svg'
import msBannerBackground from './assets/msBannerBackground.svg'
import { K5_PROGRAM_TYPE } from 'utils/program/types'
export const HeaderWrapper = styled.div.attrs(({ programType }) => ({
  backgroundImage:
    programType === K5_PROGRAM_TYPE ? elemBannerBackground : msBannerBackground,
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 3.75rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  max-width: ${themeGet('breakpoints.sizes.large')};
  color: ${themeGet('colors.white')};
`

export const NavigationBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: ${themeGet('breakpoints.sizes.large')};

  ${themeGet('breakpoints.mobileLarge')} {
    padding: 1rem;
  }
`

export const BackLinkWrapper = styled.div`
  a {
    color: ${themeGet('colors.white')};
    text-decoration: none;
    font-size: 1rem;
    font-weight: 400;
    padding-bottom: 0.5px;
    border-bottom: 1px solid transparent;
    transition: border-bottom 0.2s ease;

    &:hover {
      border-bottom: 1px solid ${themeGet('colors.white')};
      color: ${themeGet('colors.white')};
    }
  }
`

export const SiteSelectorWrapper = styled.div`
  display: flex;
  align-items: center;

  div {
    color: ${themeGet('colors.white')};
    border-bottom: 1px solid transparent;
    border-top: 1px solid transparent;

    &:hover {
      border-bottom: 1px solid ${themeGet('colors.white')};
      color: ${themeGet('colors.white')};
    }

    &:focus {
      border-bottom: 1px solid ${themeGet('colors.white')};
      color: ${themeGet('colors.white')};
    }
  }
`

export const HeaderImageBackground = styled.div.attrs(({ programType }) => ({
  backgroundImage:
    programType === K5_PROGRAM_TYPE ? elemBannerBackground : msBannerBackground,
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  background-color: ${themeGet(
    'tieredInterventionHeader.headerWrapper.backgroundColor',
  )};
  background-image: url(${({ backgroundImage }) => backgroundImage});
  background-position: ${themeGet('banners.landingBackgroundImageAlignment') ??
    'center'};
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 0;
  overflow: hidden;
`

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: ${themeGet('breakpoints.sizes.large')};
  box-sizing: border-box;
  position: relative;
  z-index: 2;
  text-align: left;

  ${themeGet('breakpoints.mobileLarge')} {
    padding: 0;
    align-items: flex-start;
  }

  ${themeGet('breakpoints.mobile')} {
    padding: 0;
  }
`

export const TierPill = styled.div`
  margin-bottom: 1.5rem;

  span {
    background: ${themeGet('colors.aliceBlue')};
    color: ${themeGet('colors.darkGray')};
    font-weight: 600;
    font-size: 0.75rem;
    letter-spacing: 0.08em;
    padding: 0.375rem 1rem;
    border-radius: 6.25rem;
  }
`

export const Title = styled.h1`
  font-size: ${themeGet('banners.headerTextSize', '2.5rem')};
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 0.5rem 0;
  color: white;
  text-align: left;
  font-family: ${themeGet('banners.headerTextFont')};

  ${themeGet('breakpoints.mobileLarge')} {
    font-size: 2rem;
  }
`

export const ProgressText = styled.p`
  font-size: 1rem;
  font-weight: 400;
  margin: 0 0 1.5rem 0;
  color: white;
  opacity: 0.9;
  text-align: left;
`

export const Description = styled.p`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  margin: 0 0 2rem 0;
  color: white;
  max-width: 75%;
  opacity: 0.9;
  text-align: left;

  ${themeGet('breakpoints.mobileLarge')} {
    max-width: 100%;
    text-align: left;
  }
`

export const TabNavigation = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 2rem;
  padding-top: 1.5rem;
  width: 100%;

  ${themeGet('breakpoints.mobileLarge')} {
    gap: 1rem;
    flex-wrap: wrap;
  }
`

export const TabButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  ${({ isActive }) =>
    isActive &&
    `
    font-weight: 600;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -0.25rem;
      left: 0;
      right: 0;
      height: 3px;
      background: white;
      border-radius: 2px;
    }
  `}
`
